'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;
// import Modal from 'react-modal'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reduxAsyncConnect = require('redux-async-connect');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactSlidedown = require('react-slidedown');

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./FundGunInvestments.css');

var FirstPage = 5;
var AllPage = 1000000;

function mapFundHoldings(fHoldings) {
  var fHoldingsMap = {};
  fHoldings.forEach(function (fholding) {
    fHoldingsMap[fholding.db_holding_id] = fholding;
  });
  return fHoldingsMap;
}

function filterHoldings(fHoldingsMap, holdings, filterFn) {
  return (0, _lodash.chain)(holdings).filter(filterFn).sortBy(function (o) {
    return fHoldingsMap[o.id].market_value * -1;
  })
  // .take(10)
  .value();
}

var propStateMap = [
// { state:'screen', prop:'screen', transform:(value)=>value }
{ state: 'err', prop: 'err', transform: function transform(value) {
    return value;
  } }];

// // convert state to query props
// const propsFromState = (state) => {
//   const props = {}

//   propStateMap.forEach((map) => {
//     // in map
//     if (typeof state[map.state] !== 'undefined' && state[map.state] !== null) {
//       // has value after transform
//       const value = map.transform(state[map.state])

//       if (typeof value !== 'undefined' && value !== null) {
//         props[map.prop] = value
//       }
//     }
//   })

//   return props
// }
// convert query props to state
var stateFromProps = function stateFromProps(props) {
  // defaults
  var state = {
    // screen: 'all',
    location: props.location
  };

  propStateMap.forEach(function (map) {
    // in map
    if (props.location.query[map.prop]) {
      // has value after transform
      var value = map.transform(props.location.query[map.prop]);

      if (typeof value !== 'undefined' && value !== null) {
        state[map.state] = value;
      }
    }
  });

  return state;
};

var FundGunInvestments = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  };
}, searchActions), _dec2 = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec3 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundGunInvestments, _Component);

  function FundGunInvestments(props) {
    (0, _classCallCheck3.default)(this, FundGunInvestments);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FundGunInvestments.__proto__ || (0, _getPrototypeOf2.default)(FundGunInvestments)).call(this, props));

    _this.getChartData = function (fund, weaponHoldings, fHoldingsMap, label, _allAsset, _allWeight, _allRating) {
      // colors
      var colors = {
        'gm': '#C3001C',
        'gm_end': '#C3001C',
        'gr': '#F2961C',
        'gr_end': '#F2961C',
        'weapons': '#C3001C',
        'weapons_lite': '#F2961C',
        'gray': '#D5D5D5',
        'green': '#D5D5D5'
      };
      // what categories are active?
      var activeSector = _this.state.activeSector;
      var allAsset = _convert2.default.int(fund[_allAsset]);
      var allWeight = _format2.default.perc(fund[_allWeight]);
      var fundRating = _convert2.default.float(fund[_allRating]);
      var capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1);
      // const capitalizedLabel = 'Gun manufacturers and major gun retailers'
      var chartData = [];

      if (activeSector && allAsset > 0) {
        // companies
        var num_colors = _convert2.default.int(fund[activeSector + '_count']);
        var scaleStart = colors[activeSector];
        var scaleEnd = colors[activeSector + '_end'];
        if (weaponHoldings.length === 1) {
          scaleEnd = scaleStart;
        }
        var f = _chromaJs2.default.scale([scaleStart, scaleEnd]).mode('rgb').colors(num_colors);
        // const shuffled = format.shuffle(f)
        var currIdx = -1;
        // // map holdings to pie chart data
        chartData = weaponHoldings.reduce(function (filtered, holding) {
          var nameLabel = _format2.default.longString(holding.security_name, 20);
          var moneyLabel = _format2.default.money(fHoldingsMap[holding.id].market_value, true, 'USD', true);
          currIdx = (currIdx + 1) % num_colors;
          filtered.push({
            value: fHoldingsMap[holding.id].market_value,
            label: nameLabel + ' ' + moneyLabel,
            color: f[currIdx]
          });
          return filtered;
        }, []);
      } else {
        if (allAsset > 0) {
          var isLite = fundRating === 2.0;
          chartData = [{
            value: allAsset,
            label: capitalizedLabel + ' stocks: ' + allWeight,
            color: isLite ? colors.weapons_lite : colors.weapons
          }, {
            value: _convert2.default.int(fund.fund_net_assets) - allAsset,
            label: 'All other holdings',
            color: colors.gray
          }];
        } else {
          chartData = [{
            value: 1,
            label: 'No ' + label + ' stock holdings',
            color: colors.green
          }];
        }
      }
      return chartData;
    };

    _this.clickViewMore = function () {
      _this.setState({ viewMore: !_this.state.viewMore });
    };

    _this.increment = function (incState) {
      return function () {
        var newState = {};
        newState[incState] = _this.state[incState] + 1;
        _this.setState(newState);
      };
    };

    _this.holdingsCount = function (count) {
      if (count > 0) {
        return _format2.default.number(count) + ' holdings';
      }

      return '';
    };

    _this.renderHoldings = function (shareClass, fHoldingsMap, holdings, page) {
      if (!holdings || holdings.length === 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'holdings-none' },
          'NONE'
        );
      }

      var takeCount = page > 1 ? AllPage : FirstPage;

      var iconGm = require('../../../static/images/icn-gm-active.svg'); // no-circle
      var iconGr = require('../../../static/images/icn-gr-active.svg'); // no-circle

      var iconConfigs = [['is_gm', iconGm, 'Civilian firearm manufacturers'], ['is_gr', iconGr, 'Civilian firearm retailers']];

      return (0, _lodash.chain)(holdings).take(takeCount).map(function (h, idx) {
        var fPerc = _format2.default.perc(fHoldingsMap[h.id].long_weight);
        var fMoney = _format2.default.money(fHoldingsMap[h.id].market_value, true, shareClass.currency, true);
        //
        return _react2.default.createElement(
          'li',
          {
            key: idx,
            styleName: 'holding'
          },
          _react2.default.createElement(
            'div',
            { styleName: 'holding-name' },
            _react2.default.createElement(
              'div',
              null,
              idx + 1,
              '. ',
              h.security_name
            ),
            _react2.default.createElement(
              'div',
              null,
              /* mini-sector icons */
              iconConfigs.map(function (sector) {
                return h[sector[0]] ? _react2.default.createElement(
                  'span',
                  {
                    key: sector[0],
                    title: sector[2]
                  },
                  _react2.default.createElement('img', {
                    styleName: 'detail-icon-holding',
                    src: sector[1],
                    alt: sector[2]
                  })
                ) : null;
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-invested' },
            fMoney
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-asset' },
            fPerc
          )
        );
      }).value();
    };

    _this.renderCompanies = function (shareClass, fHoldingsMap, type, label, count, holdings, page) {
      count = _convert2.default.int(count);
      var hasMoreButton = page === 1 && count > FirstPage ? _react2.default.createElement(
        'div',
        { styleName: 'detail-more-' + type,
          onClick: _this.increment('weaponsPage') },
        'See all',
        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-down' })
      ) : null;

      if (count === 0) {
        return null;
      }

      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { xs: 12, styleName: 'detail-holdings-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'detail-fossils' },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-title-holdings' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-' + type },
              label
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'visible-sm visible-md visible-lg detail-holdings-count-' + type },
              _this.holdingsCount(count)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'visible-xs mobile-holdings-label' },
            count,
            ' holdings'
          ),
          _react2.default.createElement(
            'ul',
            { styleName: 'detail-holdings' },
            _this.renderHoldings(shareClass, fHoldingsMap, holdings, page)
          )
        ),
        hasMoreButton
      );
    };

    _this.renderSectorDetailsSwitch = function (type, label, sublabel, count, weight, asset, currency) {
      // circle icon
      var iconNormal = require('../../../static/images/icn-' + type + '.svg');
      // circle icon filled in
      var iconActive = require('../../../static/images/icn-' + type + '-active.svg');
      // circle icon with green slash
      var iconClean = require('../../../static/images/icn-' + type + '-inactive-slash.svg');
      // clean or dirty?
      var isDirty = _convert2.default.int(count);
      // currently active?
      var isActive = type === _this.state.activeSector;
      // what style?
      var currIcon = null;
      var cleanDirtyStyle = '';

      if (isDirty) {
        if (isActive) {
          cleanDirtyStyle = 'detail-sector-' + type + '-active';
          currIcon = iconActive;
        } else {
          cleanDirtyStyle = 'detail-sector-' + type + '-normal';
          currIcon = iconNormal;
        }
      } else {
        cleanDirtyStyle = 'detail-sector-clean';
        currIcon = iconClean;
      }

      var clickSectorFn = function clickSectorFn(sectorType) {
        if (isDirty) {
          _this.clickSector(sectorType);
        }
      };

      return _react2.default.createElement(
        'div',
        {
          styleName: 'detail-sector-wrapper',
          onClick: function onClick() {
            return clickSectorFn(type);
          }
        },
        _react2.default.createElement(
          'div',
          { styleName: cleanDirtyStyle },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-sector-detail-icon-wrap' },
            _react2.default.createElement('img', {
              styleName: 'detail-icon',
              src: currIcon,
              alt: label
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-title-active' },
            _react2.default.createElement(
              'div',
              null,
              label
            ),
            sublabel ? _react2.default.createElement(
              'div',
              { styleName: 'detail-sublabel' },
              sublabel
            ) : null
          ),
          isDirty ? _react2.default.createElement(
            'div',
            { styleName: 'detail-sector-stat-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-stat-active' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-figure' },
                _format2.default.number(count)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-label' },
                'holdings'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-stat-active' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-figure' },
                _format2.default.money(asset, true, currency, true)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-label' },
                'invested'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-stat-active' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-figure' },
                _format2.default.perc(weight)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-label' },
                'of portfolio'
              )
            )
          ) : _react2.default.createElement(
            'div',
            { styleName: 'single-badge-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'single-badge-text' },
              _react2.default.createElement(
                'div',
                { styleName: 'single-badge-title' },
                '0 direct stock holdings'
              )
            )
          )
        )
      );
    };

    _this.renderMore = function (shareClass, showDataAs) {
      return _react2.default.createElement(
        'div',
        { styleName: 'more-stats' },
        _this.renderMoreButton(shareClass.date, true),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          _this.state.viewMore ? _this.renderStats(shareClass) : null
        )
      );
    };

    _this.renderMoreButton = function (portfolioDate, showDataAs) {
      var label = !_this.state.viewMore ? 'View more info' : 'View less';
      return _react2.default.createElement(
        'div',
        { styleName: 'view-more-wrapper' },
        _react2.default.createElement(
          'button',
          { styleName: 'view-more', title: label, onClick: _this.clickViewMore },
          label,
          _react2.default.createElement(_components.LinkIcon, { faclass: _this.state.viewMore ? 'fa-angle-up' : 'fa-angle-down' })
        )
      );
    };

    _this.renderStats = function (shareClass) {
      function renderCol(type, entries, hasLine) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 6, styleName: 'col-' + type + '-wrapper' },
          entries.map(function (entry, idx) {
            return _react2.default.createElement(
              'div',
              {
                key: idx,
                styleName: 'col-label-value' },
              _react2.default.createElement(
                'div',
                { styleName: 'col-' + type },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-label' },
                  entry.name
                ),
                entry.link ? _react2.default.createElement(
                  _components.Link,
                  {
                    to: entry.link,
                    title: entry.value },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'stats-value-link' },
                    entry.value
                  )
                ) : _react2.default.createElement(
                  'div',
                  { styleName: 'stats-value' },
                  entry.value
                )
              ),
              hasLine && idx !== entries.length - 1 ? _react2.default.createElement('div', { styleName: 'col-line' }) : null
            );
          })
        );
      }

      var dest = encodeURIComponent(shareClass.fund_family_name);

      return _react2.default.createElement(
        'div',
        { styleName: 'stats' },
        _react2.default.createElement(
          'div',
          { styleName: 'stats-inner' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'stats-header' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 12, lg: 12 },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-title' },
                'Mutual fund investment profile'
              )
            )
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Shareclass ticker', value: shareClass.ticker }], false),
            renderCol('right', [{ name: 'Data as of', value: (0, _moment2.default)(shareClass.date.slice(0, 10)).format('D MMM YYYY') }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Shareclass name', value: shareClass.name }], false),
            renderCol('right', [{ name: '% of fund assets screened', value: _format2.default.perc(shareClass.percent_rated) }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Shareclass type', value: _format2.default.legalType(shareClass.legal_type) }], false),
            renderCol('right', [{ name: 'Fund net assets', value: _format2.default.money(shareClass.fund_net_assets, true, shareClass.currency) }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Fund family', link: _config2.default.routes.families + '?q=' + dest, value: shareClass.fund_family_name }], false),
            renderCol('right', [{ name: 'Fund category', value: shareClass.morningstar_category_name }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Domicile country', value: _format2.default.market(shareClass.market) }], false),
            renderCol('right', [{ name: 'Portfolio currency', value: _format2.default.currencyCode(shareClass.currency) }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Non-diversification risk', value: _format2.default.boolean(shareClass.non_diversified_fund) }], false),
            renderCol('right', [{ name: 'Sustainability mandate', value: _format2.default.boolean(shareClass.socially_responsible_fund || "0") }], false)
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'stats-totals' },
            _react2.default.createElement(
              'div',
              { styleName: 'stats-totals-header' },
              'Civilian firearm totals'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total civilian firearm stock holdings'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.number(shareClass.wff_civ_count)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total % invested in civilian firearm stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.perc(shareClass.wff_civ_weight)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total assets invested in civilian firearm stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.money(shareClass.wff_civ_asset, true, shareClass.currency, false)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Civilian firearm grade'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'profile-grade-title' },
                _react2.default.createElement(_components.Grade, { grade: shareClass.grade_tobacco })
              )
            )
          )
        )
      );
    };

    _this.renderSectors = function (sector, fund, shareClass, fHoldingsMap) {
      return _react2.default.createElement(
        'div',
        { key: sector[0] },
        /* render the sector switch */
        _this.renderSectorDetailsSwitch(sector[0], sector[1], sector[2], fund[sector[3]], fund[sector[4]], fund[sector[5]], shareClass.currency),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          /* render the holding list if the sector is active */
          _this.state.activeSector === sector[0] ? _this.renderCompanies(shareClass, fHoldingsMap, sector[0], sector[1], shareClass[sector[3]], sector[6], _this.state.weaponsPage) : null
        )
      );
    };

    _this.state = (0, _assign2.default)(stateFromProps(props), {
      weaponsPage: 1,
      activeSector: '',
      viewMore: false
    });
    return _this;
  }

  (0, _createClass3.default)(FundGunInvestments, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      // const sector = this.props.sector ? this.props.sector : {}
      // let screen = ''
      // if (sector && sector.mil && !sector.civ) {
      //   screen = 'mil'
      // } else if (sector && !sector.mil && sector.civ) {
      //   screen = 'civ'
      // } else if (sector && sector.mil && sector.civ) {
      //   screen = 'all'
      // } else {
      //   screen = this.state.screen || 'all'
      // }
      // const validScreen = ['mil', 'civ', 'all'].includes(screen)
      // if (!validScreen) {
      //   screen = 'all'
      // }
      // this.selectScreen(screen)
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // window.addEventListener('scroll', this.handleScroll)
      _analytics2.default.event(_analytics2.default.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId));
      this._mounted = true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var ele = document.getElementById('anchor-top');
      window.scrollTo(ele.offsetLeft, ele.offsetTop);
      // if (props.location !== this.state.location) {
      // const state = Object.assign(this.state, stateFromProps(props))
      // this.selectScreen(state.screen)
      // }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._mounted = false;
    }
  }, {
    key: 'clickSector',


    // toggleScreens = () =>{
    //   this.setState({ showScreens: !this.state.showScreens })
    // }

    // selectScreen = (name) => {
    //   let sector = {}

    //   switch (name) {
    //     case 'all':
    //       sector = { mil: true, civ: true }
    //       break
    //     case 'mil':
    //       sector = { mil: true, civ: false }
    //       break
    //     case 'civ':
    //       sector = { mil: false, civ: true }
    //       break
    //   }

    //   this.props.sectorChange(sector)

    //   const fundName = this.props.params.name
    //   const ticker = this.props.params.ticker
    //   const fundId = this.props.params.fundId
    //   const investmentVehicleId = this.props.params.investmentVehicleId
    //   const url = config.routes.fund+'/'+fundName+'/'+ticker+'/weapon-investments/'+fundId+'/'+investmentVehicleId

    //   this.setState({
    //     activeSector: '',
    //     weaponsPage: 1,
    //     showScreens: false
    //   })

    //   // if it's a new screen, update the query
    //   if (name !== this.state.screen) {
    //     this.context.router.push({
    //       pathname: url,
    //       query: propsFromState( Object.assign(this.state,
    //         {screen: name}) )
    //     })
    //   }
    // }

    value: function clickSector(newSector) {
      this.setState({
        activeSector: newSector === this.state.activeSector ? '' : newSector,
        weaponsPage: 1
      });
    }

    // renderScreenSwitches = (activeLabel) => {
    //   function renderScreenOption(stateScreen, selectScreen, screen, label) {
    //     return (
    //       <button
    //         onClick={() => selectScreen(screen)}
    //         styleName='adjust-screens-option'
    //         role='button'
    //         tabIndex='0'
    //       >
    //         <div styleName='adjust-screens-option-inner'>
    //           <div styleName='adjust-screens-option-label'>
    //             {label}
    //           </div>
    //           <div styleName='adjust-screens-option-icon'>
    //             <i
    //               styleName='adjust-screens-icon'
    //               className={ stateScreen===screen ? 'fa fa-check-circle':'fa fa-circle-thin' }
    //             />
    //           </div>
    //         </div>
    //       </button>
    //     )
    //   }

    //   return (
    //     <div styleName='adjust-screens-wrap'>
    //       <button
    //         styleName='adjust-screens'
    //         onClick={this.toggleScreens}
    //         role='button'
    //         tabIndex='0'>

    //         <span styleName='adjust-screens-text'>
    //           <LinkIcon
    //             nospace
    //             faclass='fa-sliders'
    //           />
    //           &nbsp;
    //           Screen settings: {activeLabel}
    //           <LinkIcon
    //             faclass={this.state.showScreens
    //                      ? 'fa-angle-up'
    //                      : 'fa-angle-down'}
    //           />
    //         </span>

    //       </button>
    //       {
    //         (!this.state.showScreens) ?
    //         (<div/>) :
    //         (
    //           <div styleName='adjust-screens-panel'>
    //             { renderScreenOption(this.state.screen, this.selectScreen, 'all', 'All weapons') }
    //             { renderScreenOption(this.state.screen, this.selectScreen, 'mil', 'Military weapons') }
    //             { renderScreenOption(this.state.screen, this.selectScreen, 'civ', 'Civilian firearms') }
    //           </div>
    //         )
    //       }
    //     </div>
    //   )
    // }


  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      // const sriIcon = require( '../../../static/images/sri.svg' )
      // const ussifIcon = require( '../../../static/images/ussif-memberlogo.png' )

      function renderGradeBox(label, _grade, screen) {
        var rating = fund[_grade];
        var letterGrade = _format2.default.score(rating);
        var sfGrade = letterGrade === 'N/A' ? 'NA' : letterGrade;
        var scoreTip = _format2.default.weaponGradeTooltip('civ', letterGrade);

        var descriptions = {
          A: 'No holdings flagged for our civilian firearm screens. Assigned a grade of A.',
          B: 'Fund is invested in civilian firearm retailers, but no holdings flagged for our civilian firearm manufacturers screen. Assigned a grade of B.',
          C: 'Fund is invested in civilian firearm manufacturers, below the threshold of 0.1%. Assigned a grade of C.',
          D: 'Fund is invested in civilian firearm manufacturers, above the threshold of 0.1% and below 0.4%. Assigned a grade of D.',
          F: 'Fund is invested in civilian firearm manufacturers, above the threshold of 0.4%. Assigned a grade of F.',
          NA: 'Error'
        };
        var description = descriptions[sfGrade];

        return _react2.default.createElement(
          'div',
          { styleName: 'grade-snapshot' },
          _react2.default.createElement(
            'div',
            { styleName: 'grade-intro' },
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'strong',
                null,
                label,
                ' grade:'
              ),
              ' ',
              description
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _components.Link,
              {
                strong: true,
                to: _config2.default.routes.howitworks,
                title: 'How it works'
              },
              _react2.default.createElement(
                'strong',
                null,
                'How we track gun investments',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              styleName: 'grade-wrapper',
              'data-multiline': true,
              'data-effect': 'solid',
              'data-tip': scoreTip,
              'data-html': true,
              'data-place': 'bottom',
              'data-for': 'tooltip-grade'
            },
            _react2.default.createElement(_components.Grade, { grade: rating, large: true })
          ),
          _react2.default.createElement(_reactTooltip2.default, { id: 'tooltip-grade' })
        );
      }

      var shareClass = this.props.result.shareClass;
      var title = shareClass.fund_legal_name + ' | Gun investments';
      var fund = this.props.result.fund;
      var ticker = shareClass.ticker ? shareClass.ticker : 'N';
      var name = _format2.default.sanitize(shareClass.fund_legal_name);
      var urlStart = _config2.default.routes.fund + '/' + name + '/' + ticker;
      var urlEnd = shareClass.fund_id + '/' + shareClass.investment_vehicle_id;
      var url = _config2.default.domain + urlStart + '/gun-investments/' + urlEnd;

      // could this be cached (e.g. in state) to improve performance?
      var fHoldingsMap = mapFundHoldings(this.props.result.fund.fundholdings);
      // const weaponHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      //   return(o.is_gm  ||
      //          o.is_gr)
      // })
      var civHoldings = filterHoldings(fHoldingsMap, fund.holdings, function (o) {
        return o.is_gm || o.is_gr;
      });
      var gmHoldings = filterHoldings(fHoldingsMap, fund.holdings, function (o) {
        return o.is_gm;
      });
      var grHoldings = filterHoldings(fHoldingsMap, fund.holdings, function (o) {
        return o.is_gr;
      });

      var allHoldings = null;
      var chartMessage = null;
      var label = null;
      var activeLabel = null;
      var allCount = null;
      var allAsset = null;
      var allWeight = null;
      var allRating = null;
      // let showMil = false
      var showCiv = false;

      switch (this.state.screen) {
        default:
          allHoldings = civHoldings;
          chartMessage = 'Civilian firearms';
          label = 'gun';
          activeLabel = 'Civilian firearms';
          allCount = _config2.default.fundFields.CIV_COUNT;
          allAsset = _config2.default.fundFields.CIV_ASSET;
          allWeight = _config2.default.fundFields.CIV_WEIGHT;
          allRating = _config2.default.fundFields.CIV_RATING;
          showCiv = true;
          break;
      }
      var capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1);

      shareClass.gm_weight = fund.gm_weight;
      shareClass.gr_weight = fund.gr_weight;

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, '', url),
        _react2.default.createElement(_components.FundName, { shareClass: shareClass,
          pathname: this.props.location.pathname }),
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(
            'div',
            { styleName: 'snapshot-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'snapshot' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 12, md: 4, styleName: 'chart-sidebar-wrap' },
                  renderGradeBox(capitalizedLabel, allRating, this.state.screen),
                  this.state.activeSector === '' && _convert2.default.int(fund[allAsset]) > 0 ? _react2.default.createElement(_components.Chart, {
                    currency: shareClass.currency,
                    invested: _convert2.default.int(fund[allAsset]),
                    chartData: this.getChartData(fund, allHoldings, fHoldingsMap, label, allAsset, allWeight, allRating),
                    chartMessage: chartMessage
                  }) : null,
                  this.state.activeSector === 'gm' && _convert2.default.int(fund[allAsset]) > 0 ? _react2.default.createElement(_components.Chart, {
                    currency: shareClass.currency,
                    invested: _convert2.default.int(fund.gm_asset),
                    chartData: this.getChartData(fund, gmHoldings, fHoldingsMap, label, allAsset, allWeight, allRating),
                    chartMessage: 'Gun manufacturers'
                  }) : null,
                  this.state.activeSector === 'gr' && _convert2.default.int(fund[allAsset]) > 0 ? _react2.default.createElement(_components.Chart, {
                    currency: shareClass.currency,
                    invested: _convert2.default.int(fund.gr_asset),
                    chartData: this.getChartData(fund, grHoldings, fHoldingsMap, label, allAsset, allWeight, allRating),
                    chartMessage: 'Major gun retailers'
                  }) : null,
                  _react2.default.createElement(_components.FlaggedFund, {
                    count: _convert2.default.int(fund[allCount]),
                    weight: _convert2.default.float(fund[allWeight]),
                    asset: _convert2.default.int(fund[allAsset]),
                    portfolioDate: fund.date,
                    label: label
                  })
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 12, md: 8, styleName: 'main-content-wrap' },
                  this.state.screen === 'civ' && _convert2.default.int(fund[_config2.default.fundFields.CIV_COUNT]) === 0 ? _react2.default.createElement(
                    'div',
                    { styleName: 'flagged-fund-clean' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'flagged-fund-clean-title' },
                      'This fund is clean for both of our civilian firearm categories!'
                    )
                  ) : null,
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sector-details-info' },
                    _react2.default.createElement('i', { className: 'fa fa-info-circle' }),
                    ' For each civilian firearm category, we show the fund\'s exposure. Click a category to see the breakdown of companies. When calculating a portfolio\'s exposure to a screen list, we only consider long investments, ignoring any shorts or liabilities.'
                  ),
                  showCiv ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'div',
                      { styleName: 'sector-details-info-label-utility' },
                      'Civilian firearms'
                    ),
                    /* Sector switches + company lists */
                    [['gm', 'Gun manufacturers', 'Manufacturers of civilian firearms', 'gm_count', 'gm_weight', 'gm_asset', gmHoldings], ['gr', 'Major gun retailers', 'Largest public retailers of civilian firearms', 'gr_count', 'gr_weight', 'gr_asset', grHoldings]].map(function (sector) {
                      return _this2.renderSectors(sector, fund, shareClass, fHoldingsMap);
                    })
                  ) : null,
                  _convert2.default.int(fund[allCount]) ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'div',
                      null,
                      this.state.activeSector === '' ? this.renderCompanies(shareClass, fHoldingsMap, 'weapons', 'Gun manufacturers and major gun retailers', shareClass[allCount], allHoldings, this.state.weaponsPage) : null
                    )
                  ) : _react2.default.createElement(
                    'div',
                    { styleName: 'clean-funds-link' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'clean-funds-headline' },
                      'Want to learn how to add gun free funds to your retirement plan?'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'clean-funds-info' },
                      'Use our Gun Free Action Toolkit and get started moving your money'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'clean-funds-btn-wrap' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.toolkit,
                          primarybutton: true,
                          title: 'Gun free action toolkit'
                        },
                        _react2.default.createElement(
                          'div',
                          null,
                          'Gun free action toolkit',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    )
                  )
                )
              ),
              this.renderMore(shareClass),
              _react2.default.createElement(_components.Tweeter, {
                type: 'fund',
                item: shareClass,
                label: label,
                screen: this.state.screen
              })
            )
          )
        ),
        _react2.default.createElement(_components.IyvScorecard, {
          fund: fund,
          shareClass: shareClass
        }),
        _react2.default.createElement(_components.FundShareTakeAction, {
          fund: fund,
          shareClass: shareClass,
          url: url,
          screen: this.state.screen
        })
      );
    }
  }]);
  return FundGunInvestments;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = FundGunInvestments;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundGunInvestments/FundGunInvestments.js
// module id = 1289
// module chunks = 0